import { applyMiddleware, compose, createStore, Store } from "redux";
import thunk from "redux-thunk";
import createRootReducer, { IRootState } from "../reducer/CombineReducer";

export const composeStore = (): any =>
  compose(applyMiddleware(thunk));

export const getStore = (): Store<IRootState> =>
  createStore(createRootReducer(), composeStore());
